import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import update from 'immutability-helper';
import './ConsultantReferralForm.scss';
import grayLogo from '../../../assets/images/Logo_Gray.svg';
import ConsultantForm from '../Registration/ConsultantForm';
import ConsultantReferralsReceived from './ConsultantReferralsReceived';
import SignInForm from '../SignInForm';
import ExpertiseTagDropdown from '../common/ExpertiseTagDropdown';
import { postRequest, getRequest } from '../../requestUtils';
import { emailRegex } from '../../formValidators';

const maxItems = 100;

const filterPicklist = (picklist, input) => picklist.filter(
  (record) => record.label.toLowerCase().includes(input.toLowerCase()),
).slice(0, maxItems);

class ConsultantReferralForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 'invite-consultants',
      consultants: [{
        name: '',
        validName: true,
        email: '',
        validEmail: true,
        id: `0${Date.now()}`,
        linkedInUrl: '',
        selectedAoe: [],
        isSelectedAoe: true,
      }],
      recommendationIds: [],
      referrerName: '',
      validReferrerName: true,
      picklist: [],
    };

    this.switchToStep = this.switchToStep.bind(this);
    this.addNewConsultantFields = this.addNewConsultantFields.bind(this);
    this.removeConsultant = this.removeConsultant.bind(this);
    this.updateField = this.updateField.bind(this);
    this.consultantFields = this.consultantFields.bind(this);
    this.createRecommendations = this.createRecommendations.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getProjectDetails = this.getProjectDetails.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.getProjectDetails();
  }

  getProjectDetails() {
    getRequest('/recommendations/aoe_select_options')
      .then(({ data }) => {
        this.setState({ picklist: data });
      });
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  }

  switchToStep(step) {
    return () => (this.setState({ step }));
  }

  addNewConsultantFields() {
    const { consultants } = this.state;
    this.setState({
      consultants: update(
        consultants,
        {
          $push: [{
            name: '',
            validName: true,
            email: '',
            validEmail: true,
            id: `${consultants.length}${Date.now()}`,
            linkedInUrl: '',
            selectedAoe: [],
            isSelectedAoe: true,
          }],
        },
      ),
    });
  }

  validateForm(referrerName, consultants) {
    const { validReferrerName } = this.state;
    const { anonymous } = this.props;
    let allValid = true;
    const validatedConsultants = [];

    if (anonymous) {
      this.setState({ validReferrerName: referrerName.length > 0 });
    }

    consultants.forEach((consultant) => {
      const index = consultants.findIndex((c) => c.id === consultant.id);
      const validatedConsultant = update(consultant, {
        validName: { $apply() { return consultant.name.length > 0; } },
        validEmail: { $apply() { return emailRegex.test(consultant.email); } },
        isSelectedAoe: { $apply() { return consultant.selectedAoe.length > 0; } },
      });
      validatedConsultants[index] = validatedConsultant;
      if (consultant.name.length <= 0 || !emailRegex.test(consultant.email)
          || consultant.selectedAoe.length === 0) {
        allValid = false;
      }
    });
    this.setState({ consultants: validatedConsultants });
    return allValid && validReferrerName;
  }

  createRecommendations() {
    const {
      createRecommendationsPath, csrfToken, projectId, anonymous,
    } = this.props;
    const { consultants, referrerName } = this.state;

    if (this.validateForm(referrerName, consultants)) {
      consultants.forEach((consultant) => {
        consultant.linked_in_url = consultant.linkedInUrl;
        consultant.area_of_expertise = consultant.selectedAoe.map(({ label: name, value: id }) => ({ id, name }));
      });

      postRequest(
        createRecommendationsPath,
        { project_id: projectId, referrer_name: referrerName, recommendations: consultants },
        csrfToken,
      ).then(({ data }) => {
        const { recommendation_ids: recommendationIds } = data;
        if (recommendationIds.length) {
          this.setState({ step: anonymous ? 'signup' : 'thank-you', recommendationIds });
        }
      }).catch(() => (
        this.setState({ recommendationError: 'Something has gone wrong. Please try again later.' })
      ));
    }
  }

  removeConsultant(consultant) {
    return (event) => {
      event.preventDefault();

      const { consultants } = this.state;
      const index = consultants.findIndex((elem) => elem.id === consultant.id);

      if (index === -1) {
        return;
      }

      this.setState({ consultants: update(consultants, { $splice: [[index, 1]] }) });
    };
  }

  updateField(fieldName, consultant) {
    return (event) => {
      const { consultants } = this.state;
      const index = consultants.findIndex((elem) => elem.id === consultant.id);

      if (index === -1) {
        return;
      }

      const newConsultant = { ...consultants[index] };
      newConsultant[fieldName] = event.target.value;

      this.setState({ consultants: update(consultants, { $splice: [[index, 1, newConsultant]] }) });
    };
  }

  handleSelect(model, multi, id) {
    const { consultants } = this.state;
    const newConsultants = [...consultants];

    return ((tags) => {
      const consultantIndex = newConsultants.findIndex((c) => c.id === id);

      if (consultantIndex !== -1) {
        newConsultants[consultantIndex] = {
          ...newConsultants[consultantIndex],
          selectedAoe: tags,
        };

        this.setState({ consultants: newConsultants });
      }
    });
  }

  consultantFields() {
    const { consultants, picklist } = this.state;

    return consultants.map((consultant) => (
      <div className="consultant-fields" key={`consultant-${consultant.id}`}>
        <div
          className={`float-end remove-consultant ${consultants.length === 1 && 'd-none'}`}
        >
          <button type="button" className="bg-danger" onClick={this.removeConsultant(consultant)}>&times;</button>
        </div>

        <div className="form-group">
          <label htmlFor={`consultant-name-${consultant.id}`} className="medium-weight">
            Consultant name
            <div className="heading-required">* Required</div>
          </label>
          { !consultant.validName
            && (
            <div className="text-danger body-text-3 regular">
              Please fill in this field.
            </div>
            )}
          <input
            type="text"
            id={`consultant-name-${consultant.id}`}
            className="form-control fs-hide"
            placeholder="Jane Doe"
            onChange={this.updateField('name', consultant)}
          />
        </div>

        <div className="form-group">
          <label htmlFor={`email-${consultant.id}`} className="medium-weight">
            Email
            <div className="heading-required">* Required</div>
          </label>
          { !consultant.validEmail
            && (
            <div className="text-danger body-text-3 regular">
              Please enter a valid email address.
            </div>
            )}
          <input
            type="email"
            id={`email-${consultant.id}`}
            className="form-control fs-hide"
            placeholder="janedoe@gmail.com"
            onChange={this.updateField('email', consultant)}
          />
        </div>

        <div className="form-group">
          <label htmlFor={`consultant-name-${consultant.id}`} className="medium-weight">LinkedIn Url</label>
          <input
            type="text"
            id={`consultant-name-${consultant.id}`}
            className="form-control fs-hide"
            onChange={this.updateField('linkedInUrl', consultant)}
          />
        </div>

        <div className="form-group">
          { !consultant.isSelectedAoe
          && (
          <div className="text-danger body-text-3 regular">
            Select at least 1 functional area
          </div>
          )}
          <ExpertiseTagDropdown
            model="area_of_expertise"
            selection={consultant.selectedAoe}
            handleSelect={(model, multi) => this.handleSelect(model, multi, consultant.id)}
            multi
            heading="Functional Areas"
            showMenuFooter={false}
            picklist={picklist}
            loadOptions={(input) => (
              new Promise((resolve) => { resolve(filterPicklist(picklist, input)); })
            )}
          />
        </div>
      </div>
    ));
  }

  progressBar() {
    const { anonymous } = this.props;
    const { step } = this.state;

    if (!anonymous) {
      return null;
    }

    const inviteStep = step === 'invite-consultants';
    const rewardStep = step === 'signup' || step === 'signin';

    return (
      <div className="mb-3 clearfix">
        <div className="col-md-6 p-0">
          <div className={`mb-2 ps-2 ${inviteStep ? 'accent-emphasis-primary' : 'invisible'}`}>
            <strong>1. Invite consultants</strong>
          </div>
          <div className={`small ${inviteStep ? 'bg-accent-emphasis-primary' : 'bg-primary-light'}`}>
            <ProgressBar now={100} />
          </div>
        </div>

        <div className="col-md-6 ps-2 pe-0">
          <div className={`mb-5 ps-2 ${rewardStep ? 'accent-emphasis-primary' : 'invisible'}`}>
            <strong>2. Be rewarded</strong>
          </div>
          <div className={`small ${rewardStep ? 'bg-accent-emphasis-primary' : 'bg-iron'}`}>
            <ProgressBar now={rewardStep ? 100 : 0} />
          </div>
        </div>
      </div>
    );
  }

  form() {
    const { step, recommendationIds, validReferrerName } = this.state;
    const { anonymous } = this.props;

    if (step === 'invite-consultants') {
      return (
        <div className="invite-consultants p-2 px-md-5 py-md-3">
          { anonymous
            && (
            <div className="form-group">
              <label htmlFor="referrer-name" className="medium-weight">Tell us your name</label>
              { !validReferrerName
                && (
                <div className="text-danger body-text-3 regular">
                  Please fill in this field.
                </div>
                )}
              <input
                type="text"
                value={this.state.referrerName}
                name="referrerName"
                id="referrer-name"
                className="form-control fs-hide"
                placeholder="John Doe"
                onChange={this.handleInputChange}
              />
            </div>
            )}
          <h5 className="uppercase-bold my-2 text-center">YOUR REFERRALS</h5>
          {this.consultantFields()}

          <div className="mb-3">
            <a href="# " onClick={this.addNewConsultantFields} className="add-another-referral">
              <i className="fas fa-plus pe-3" />
              Add more referrals
            </a>
          </div>

          <input
            type="submit"
            value="Send invites"
            onClick={this.createRecommendations}
            className="btn btn-primary"
            id="consultant-create-recommendations"
          />
        </div>
      );
    } if (step === 'signup') {
      return (
        <div className="signup">
          <div className="mb-3">
            Join Clora to get your reward and track the progress of your referrals in the platform.
          </div>

          <div className="mb-3">
            <strong className="medium-demibold">
              Already have an account?
              {' '}
              <a href="# " className="ms-2" id="recommendation-sign-in" onClick={this.switchToStep('signin')}>Log In</a>
            </strong>
          </div>

          <ConsultantForm userName={this.state.referrerName} {...this.props}>
            <input type="hidden" name="recommendation_ids" value={recommendationIds} />
          </ConsultantForm>
        </div>
      );
    } if (step === 'signin') {
      return (
        <div className="signin">
          <div className="mb-3">
            Join Clora to get your reward and track the progress of your referrals in the platform.
          </div>

          <div className="mb-3">
            <strong>
              Don&#39;t have an account?
              {' '}
              <a href="# " className="ms-2" id="recommendation-sign-up" onClick={this.switchToStep('signup')}>Sign Up</a>
            </strong>
          </div>

          <SignInForm {...this.props} submitId="consultant-sign-in">
            <input type="hidden" name="recommendation_ids" value={recommendationIds} />
          </SignInForm>
        </div>
      );
    }
    return null;
  }

  render() {
    const { step, recommendationIds } = this.state;
    const { referralsPath } = this.props;

    if (step === 'thank-you') {
      return (
        <ConsultantReferralsReceived
          notOne={recommendationIds.length !== 1}
          referralsPath={referralsPath}
        />
      );
    }

    return (
      <div className="modal-style style-guide">
        <div className="text-center title mb-3">
          <div><img src={grayLogo} alt="" height="38" width="90" /></div>
          <h1 className="modal-header">
            Connect consultants with relevant projects matching their interests and expertise.
          </h1>
          <div className="subtext">Earn $500 when your referral matches a project!</div>
        </div>
        <div className="form-wrapper">
          {this.progressBar()}
          {this.form()}
        </div>
      </div>
    );
  }
}

ConsultantReferralForm.propTypes = {
  createRecommendationsPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  anonymous: PropTypes.bool.isRequired,
  referralsPath: PropTypes.string.isRequired,
};

export default ConsultantReferralForm;
